import InstagramStorySchema from "@apps/instagram/schemas/InstagramStorySchema";
import { array } from "superstruct";

const InstagramStoriesResponseSchema = array(InstagramStorySchema);

export default InstagramStoriesResponseSchema;
